module.exports = __webpack_public_path__ + "img/stock2.b244547b.png";